export default "__VITE_ASSET__j1vANmx___"